import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.11@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ie-custom-5",
  "use": "icon-ie-custom-5-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ie-custom-5\">\n    <path d=\"M962 512c0 248.52857168-201.47142832 450-450 450S62 760.52857168 62 512 263.47142832 62 512 62s450 201.47142832 450 450z\" fill=\"#52C41A\" p-id=\"2672\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol